import firebase from 'firebase/compat/app';
import FileStorageError from './storageErrors';

export async function getDownloadUrlByPath(path) {
  if (path.startsWith('gs://')) {
    return firebase.storage().refFromURL(path).getDownloadURL();
  }
  return firebase.storage().ref(path).getDownloadURL();
}


export function getFileCloudStorageURI(filePath) {
  const ref = firebase.storage().ref(filePath);

  return `gs://${ref.bucket}/${ref.fullPath}`;
}

export async function storeTemporaryDocument(
  organizationId,
  contentType,
  file,
  title,
  progressCallback,
) {
  const bucket = firebase.storage().ref();

  file.upload.title = title || file.upload.filename;
  const { uuid } = file.upload;
  const filePath = `/upload/${organizationId}/${uuid}`;
  const temporaryFile = bucket.child(filePath);

  let contentToSave = file;
  let contentTypeToSave = contentType;
  if (contentType.endsWith(';base64')) {
    contentToSave = Buffer.from(file, 'base64');
    contentTypeToSave = contentType.replace(';base64', '');
  }

  try {
    const uploadTask = temporaryFile.put(contentToSave, {
      contentType: contentTypeToSave,
    });
    uploadTask.on('state_changed', progressCallback);
  } catch (error) {
    console.error(`Failure while storing temporary file for ${filePath}`, error);
    throw new FileStorageError(organizationId, uuid, error.message);
  }

  return uuid;
}

export async function storeFile(
  contentType,
  file,
  title,
  bucketPath,
  progressCallback,
) {
  // throw new Error('UploadError!!!');

  const bucket = firebase.storage().ref();

  const temporaryFile = bucket.child(bucketPath);

  let contentToSave = file;
  let contentTypeToSave = contentType;
  if (contentType.endsWith(';base64')) {
    contentToSave = Buffer.from(file, 'base64');
    contentTypeToSave = contentType.replace(';base64', '');
  }

  try {
    console.log('Launching upload task for file', contentTypeToSave, file, title, bucketPath);
    const uploadTask = temporaryFile.put(contentToSave, {
      contentType: contentTypeToSave,
      contentDisposition: `filename="${file.name}"`,
    });
    uploadTask.on('state_changed', progressCallback);
  } catch (error) {
    console.error(`Failure while storing temporary file for ${bucketPath}`, error);
    throw new FileStorageError(bucketPath, undefined, error.message);
  }

  return bucketPath;
}
